import { render, staticRenderFns } from "./TeamScore.vue?vue&type=template&id=237846e9&scoped=true"
import script from "./TeamScore.vue?vue&type=script&lang=js"
export * from "./TeamScore.vue?vue&type=script&lang=js"
import style0 from "./TeamScore.vue?vue&type=style&index=0&id=237846e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237846e9",
  null
  
)

export default component.exports